var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3335 14C2.3335 9.60024 2.3335 7.40036 3.70033 6.03352C5.06717 4.66669 7.26705 4.66669 11.6668 4.66669H16.3335C20.7333 4.66669 22.9332 4.66669 24.3 6.03352C25.6668 7.40036 25.6668 9.60024 25.6668 14C25.6668 18.3998 25.6668 20.5997 24.3 21.9665C22.9332 23.3334 20.7333 23.3334 16.3335 23.3334H11.6668C7.26705 23.3334 5.06717 23.3334 3.70033 21.9665C2.3335 20.5997 2.3335 18.3998 2.3335 14Z",
    stroke: "#939CB4",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.6667 18.6667H7",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.3335 18.6667H14.5835",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.3335 11.6667L25.6668 11.6667",
    stroke: "#939CB4",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/balance.934de2da3fd2cbcb04fe735860bf739a.svg";
export { ForwardRef as ReactComponent };